import { IconThumbsUpRed } from 'assets/icons';
import { ActionButton } from 'styles/global.styles';
import { theme } from 'styles/theme';

import ImageIcon from 'components/Icon/ImageIcon';
import styled from 'styled-components';

export interface ISegment {
  title: string;
  selected: boolean;
}
interface ISegmentCard extends ISegment {
  onClick?: () => void;
}

interface ISegmentList {
  data?: ISegment[];
  onSelect: (index: number) => void;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled: boolean;
}

const SegmentCard = ({ title, selected, onClick }: ISegmentCard): JSX.Element => {
  return (
    <Card role="button" onClick={onClick} $selected={selected}>
      <ThumbsUp $visible={selected} src={IconThumbsUpRed} alt="Segment thumbs up icon" />
      <Title $selected={selected}>{title}</Title>
    </Card>
  );
};

export const Segments = (props: ISegmentList): JSX.Element => {
  return (
    <>
      <Wrapper>
        {props.data?.map((segment, index) => (
          <SegmentCard
            key={index}
            title={segment.title}
            selected={segment.selected}
            onClick={() => props.onSelect(index)}
          />
        ))}
      </Wrapper>
      <ActionButton disabled={props.disabled} onClick={props.onClick}>
        Fortsätt
      </ActionButton>
    </>
  );
};

export default Segments;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: ${theme.columns.gap};
  width: 100%;
  max-width: 768px;
`;

const Card = styled.div<{ $selected?: boolean }>`
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  background-color: ${theme.colors.content_background};
  gap: ${theme.columns.gap};
  border-radius: ${theme.dimensions.components.borderRadius};
  transition: border 0.3s ease-in-out;

  border: ${({ $selected }) =>
    $selected ? `2px solid ${theme.colors.selectedBorder}` : `1px solid ${theme.colors.border}`};
  box-shadow: ${({ $selected }) =>
    $selected ? '0 8px 24px rgba(25, 113, 73, 0.18)' : '0 2px 8px rgba(0, 0, 0, 0.04)'};

  width: 100%;
  min-height: 150px;
  padding: 0 1rem;
  margin: 0;

  &:hover {
    border: 2px solid
      ${({ $selected }) => ($selected ? theme.materials.selectedBorder : theme.colors.grayscale)};
  }
`;

const Title = styled.span<{ $selected: boolean }>`
  font-weight: 600;
  font-size: 1rem;

  color: ${({ $selected }) =>
    $selected ? `${theme.colors.primary}` : `${theme.colors.secondary_text}`};
  transform: ${({ $selected }) => ($selected ? 'translateY(75%)' : 'translateY(0)')};
  transition:
    color 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275),
    transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
`;

const ThumbsUp = styled(ImageIcon)<{ $visible: boolean }>`
  height: 40px;
  position: absolute;
  opacity: ${({ $visible }) => ($visible ? '1' : '0')};
  transform: ${({ $visible }) => ($visible ? 'translateY(-45%)' : 'translateY(10%)')};
  transition:
    transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275),
    opacity 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
`;
